import { Component, HostBinding, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.less'],
  animations: [
    trigger('openClose', [

      transition(':enter', [
        style({opacity: 0}),
        animate('0.3s', style({opacity: 1}))
      ]),
  
      transition(':leave', [
        style({opacity: 1}),
        animate('0.1s', style({opacity: 0}))
      ]),
      
    ]),
  ]
})
export class LoaderComponent implements OnInit {
  
  @HostBinding('@openClose') animation = true;

  constructor() { }

  ngOnInit(): void {
  }

}
